import React from 'react';
const bonuses = [{
  icon: '🔥',
  title: 'Planificador 12 Meses',
  desc: 'Todo el año en 30 minutos.'
}, {
  icon: '📅',
  title: 'Evaluación Express',
  desc: 'Ubicá al alumno en su tomo en 5 min.'
}, {
  icon: '🎛️',
  title: 'Variaciones Instantáneas',
  desc: '3 niveles por ejercicio en 60 seg.'
}, {
  icon: '💬',
  title: 'Scripts del Profe Pro',
  desc: '30 frases para ordenar y motivar.'
}, {
  icon: '🛡️',
  title: 'Checklist de Seguridad',
  desc: 'Protocolo completo + emergencias.'
}, {
  icon: '🆘',
  title: 'Pack "Clase Rescate"',
  desc: '12 planes B para días caóticos.'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0F] py-16 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-4">
            + <span className="text-[#FF6B00]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-[#B0B0C0] text-sm" data-id="element-6">
            Incluidos sin costo extra · Valor total:{' '}
            <span className="text-[#FFD700] font-bold line-through" data-id="element-7">
              USD 47
            </span>{' '}
            <span className="text-[#00C2FF] font-black" data-id="element-8">GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-9">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl p-4 text-center relative" data-id="element-10">
              <span className="absolute top-2 right-2 text-[#00C2FF] font-black text-[9px] bg-[#00C2FF]/10 px-1.5 py-0.5 rounded-full" data-id="element-11">
                GRATIS
              </span>
              <span className="text-3xl block mb-2" data-id="element-12">{bonus.icon}</span>
              <h4 className="text-white font-bold text-xs sm:text-sm mb-1" data-id="element-13">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-[10px] sm:text-xs leading-snug" data-id="element-14">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}